export default function(message) {
  throw Error(message);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-util/src/error.js
// module id = 222
// module chunks = 0